import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import {FleetChecklistEditorService} from '../../services/fleet-checklist-editor.service';
import {SelectableVehicle} from '../../models/vehicle-validation';

@Component({
  selector: 'app-validation-vehicle-selection',
  templateUrl: './validation-vehicle-selection.component.html',
  styleUrls: ['./validation-vehicle-selection.component.scss', '../../styles/styles-component.scss']
})
export class ValidationVehicleSelectionComponent implements OnInit {
  public selectedVehiclesSearchQuery: string = '';

  constructor(
    public editor: FleetChecklistEditorService
  ) { }

  ngOnInit(): void {}
  get vehicleSelected() {
    return this.editor.vehicles
  }
  getSelectedVehiclesFiltered(): any[] {
    if (!this.selectedVehiclesSearchQuery) return this.vehicleSelected;
    const query = this.selectedVehiclesSearchQuery.toLowerCase();
    return this.vehicleSelected.filter((v) => {
      const matchPlate = v.plate && v.plate.toLowerCase().includes(query);
      const matchCode = v.unitCode && v.unitCode.toLowerCase().includes(query);
      return matchPlate || matchCode;
    });
  }
  removeVehicle(vehicle: SelectableVehicle): void {
    this.editor.removeVehicle(vehicle.id);
  }
}
